<template>
    <div
        style="height: 100vh; display: flex; flex-direction: column; overflow-y: scroll;"
    >
        <v-card id="details" :loading="loading" style="flex-grow: 1;">
            <v-card-title ref="title" class="sticky-header mb-4">
                <v-btn small icon @click="close" color="primary" class="mr-2">
                    <v-icon>
                        mdi-close
                    </v-icon>
                </v-btn>
                <h3>
                    {{ 'Supplier Evaluation Form' }}
                </h3>
                <v-spacer />
                <v-btn
                    rounded
                    :loading="loading"
                    :disabled="loading"
                    color="primary"
                    class="mx-2"
                    @click="save"
                >
                    SAVE
                </v-btn>
            </v-card-title>
            <v-card-text>
                <div
                    v-for="(group, category) in visibleGroups"
                    :key="category"
                    class="mb-6"
                >
                    <v-row>
                        <v-col cols="11" sm="11" md="11" lg="11">
                            <h4 class="mb-4 font-weight-bold">
                                {{ category }}
                            </h4>
                        </v-col>
                        <v-col cols="1" sm="1" md="1" lg="1">
                            <h4 class="mb-4 font-weight-bold ">
                                {{ 'Score' }}
                            </h4>
                        </v-col>
                    </v-row>

                    <v-row class="ml-4" dense>
                        <v-col
                            v-for="question in group"
                            :key="question.variable"
                            cols="12"
                            sm="12"
                            md="12"
                            lg="12"
                        >
                            <div class="mb-2">
                                {{ question.question }}
                            </div>
                            <v-row>
                                <v-col cols="11" sm="11" md="11" lg="11">
                                    <v-select
                                        :items="question.options"
                                        item-text="text"
                                        item-value="value"
                                        v-model="evaluation[question.variable]"
                                        outlined
                                        dense
                                    />
                                </v-col>
                                <v-col cols="1" sm="1" md="1" lg="1">
                                    <div class="ma-0 pa-0 mt-2 align-center">
                                        {{
                                            evaluation[question.variable] ===
                                            'YES'
                                                ? 1 *
                                                  Number(question.score || 0)
                                                : evaluation[
                                                      question.variable
                                                  ] === 'PARTIALLY'
                                                ? 0.5 *
                                                  Number(question.score || 0)
                                                : 0
                                        }}/{{ question.score }}
                                    </div>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </div>
                <v-row>
                    <v-col cols="11" sm="11" md="11" lg="11">
                        <h4 class="mb-4 font-weight-bold">
                            Notas:
                        </h4>
                    </v-col>
                    <v-col cols="12" sm="12" md="12" lg="12">
                        <v-textarea
                            solo
                            v-model="evaluation[typeForm + 'Notes']"
                        ></v-textarea>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </div>
</template>
<script>
import { mapMutations } from 'vuex'
import API from '@/services/api'
import { objDiff } from '@/helpers/objDiff.js'

export default {
    name: 'SupplierEvaluationForm',
    props: {
        questions: {
            type: Array,
            default: () => [],
            required: true,
        },
        supplier: {
            type: Object,
            default: () => ({}),
            required: true,
        },
        evaluationInfo: {
            type: Object,
            default: () => ({}),
        },
        typeForm: {
            type: String,
            default: '',
            required: true,
        },
        editEvaluation: {
            type: Boolean,
            default: false,
            required: true,
        },
        initialEvaluation: {
            type: Boolean,
            default: false,
            required: true,
        },
    },
    data: () => ({
        loading: false,
        user: {},
        evaluation: {},
    }),
    computed: {
        groupedQuestions() {
            const safeQuestions = Array.isArray(this.questions)
                ? this.questions
                : []
            return safeQuestions.reduce((groups, q) => {
                if (!groups[q.category]) groups[q.category] = []
                groups[q.category].push(q)
                return groups
            }, {})
        },
        visibleGroups() {
            if (!this.groupedQuestions) return {}
            const result = {}

            for (let [category, group] of Object.entries(
                this.groupedQuestions
            )) {
                if (!Array.isArray(group)) {
                    group = []
                }
                const filter = group.filter(q => q.permission === this.typeForm)
                if (Array.isArray(filter) && filter.length) {
                    result[category] = filter
                }
            }
            return result
        },
    },
    async mounted() {
        try {
            this.loading = true
            const {
                data: { user },
            } = await API.getMyInfo()
            this.user = user
            this.questions.forEach(q => {
                this.$set(this.evaluation, q.variable, '')
            })
            this.evaluation[this.typeForm + 'Notes'] = ''
            this.evaluation = { ...this.evaluation, ...this.evaluationInfo }
            this.evaluation[this.typeForm + 'Edit'] = this.user.id

            if (!this.editEvaluation) {
                if (!this.initialEvaluation) {
                    this.evaluation.evaluationType = 'reevaluation'
                } else {
                    this.evaluation.evaluationType = 'initial'
                }
            }
        } catch (error) {
            this.setErrorItems({
                source: this.$options.name,
                message: error.message,
            })
        } finally {
            this.loading = false
        }
    },
    methods: {
        ...mapMutations(['setErrorItems']),
        close() {
            this.$emit('close')
        },
        cleanObject(obj) {
            for (const key in obj) {
                const value = obj[key]

                if (
                    value &&
                    typeof value === 'object' &&
                    !Array.isArray(value)
                ) {
                    this.cleanObject(value)
                    if (Object.keys(value).length === 0) {
                        delete obj[key]
                    }
                } else if (Array.isArray(value)) {
                    value.forEach(item => {
                        if (item && typeof item === 'object') {
                            this.cleanObject(item)
                        }
                    })
                    if (value.length === 0) {
                        delete obj[key]
                    }
                } else if (
                    value === null ||
                    value === undefined ||
                    value === ''
                ) {
                    delete obj[key]
                }
            }
            return obj
        },
        async save() {
            if (this.loading) return
            try {
                this.loading = true
                const variablesPerArea = Object.values(this.visibleGroups)
                    .flat()
                    .map(q => q.variable)
                const evaluationToSave = this.cleanObject(this.evaluation)
                let totalScorePerArea = 0
                for (const variable of variablesPerArea) {
                    const question = this.questions.find(
                        q => q.variable === variable
                    )
                    if (!question) continue
                    const score = question.score || 0
                    const answer = evaluationToSave[variable]
                    let factor = 0
                    if (answer === 'YES') {
                        factor = 1
                    } else if (answer === 'PARTIALLY') {
                        factor = 0.5
                    }
                    totalScorePerArea += factor * score
                }
                evaluationToSave[this.typeForm + 'Score'] = totalScorePerArea
                const hasAllKeys = variablesPerArea.every(
                    key => key in evaluationToSave
                )
                if (hasAllKeys) {
                    evaluationToSave[this.typeForm + 'Closed'] = true
                } else {
                    evaluationToSave[this.typeForm + 'Closed'] = false
                }

                let diff = objDiff(this.evaluationInfo, evaluationToSave)
                let evaluation = {}
                if (!(Object.keys(diff).length === 0) && this.supplier.id) {
                    diff.supplierId = this.supplier.id
                    if (this.editEvaluation) {
                        diff.evaluationId = this.evaluationInfo.id
                        evaluation = await API.updateSupplierEvaluation(diff)
                    } else {
                        evaluation = await API.createSupplierEvaluation(diff)
                    }

                    this.$emit('updateEvaluation', evaluation)
                }
                this.close()
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },
    },
}
</script>
<style>
.sticky-header {
    position: sticky;
    top: 0;
    z-index: 20;
    background-color: white;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}
</style>
